import React, { useContext, useEffect, useRef, useState } from "react";
import "./ProfileBanner.css";
import "./../../common_components/common_css/Common.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";
import { GETProfile } from "../../../features/admin/auth/Slice";

const ProfileBanner = () => {
  const fileInputRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const { userdata } = useContext(Context);
  const [copied, setCopied] = useState(false);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
    }
  };

  const joinedDate = userdata?.created_at
    ? new Date(userdata.created_at).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  const handleCopy = () => {
    navigator.clipboard.writeText(levelprofile);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const dispatch = useDispatch();
  const levelprofile = useSelector(
    (state) => state?.auth?.login?.getCustomerData?.own_referral_code,
  );

  useEffect(() => {
    dispatch(GETProfile());
  }, [dispatch]);

  return (
    <section className="profile-section">
      <div className="profile-banner-bg"></div>
      <div className="profile-banner container">
        <div className="profile-banner-content">
          <div className="profile-image-wrapper">
            <div className="first-border">
              <div className="second-border">
                <div className="profile-image">
                  {profileImage ? (
                    <img src={profileImage} alt="Profile" />
                  ) : userdata?.profile_photo ? (
                    <img
                      src={`${IDS.IMG_URL}${encodeURI(
                        userdata?.profile_photo,
                      )}`}
                      alt="Profile"
                    />
                  ) : // userdata?.name?.charAt(0)?.toUpperCase() || "PP"
                  userdata?.name ? (
                    userdata.name
                      .split(" ")
                      .map((word) => word[0])
                      .join("")
                      .toUpperCase()
                      .slice(0, 2)
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {/* <div className="edit-icon" onClick={handleEditClick}>
              <FontAwesomeIcon icon={faPen} />
            </div> */}

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageChange}
              hidden
            />
          </div>

          <div className="profile-info">
            <div className="profile-detail-section">
              <h4>+91 {userdata?.mobile_number}</h4>
              <p className="join-date">Joined Date {joinedDate}</p>{" "}
            </div>
            <div className="profile-stats">
              <span>
                <img src="images/profile/star2.png" alt="not" />{" "}
                <strong>Referrer</strong>
              </span>
            
              {/* <span>
                <img src="images/profile/star.png" alt="not" />{" "}
                <strong>30 Pts</strong>
              </span> */}

           <span className="divider">|</span>
              <span>
                <img src="images/profile/star.png" alt="not" />{" "}
                <strong>Refferal Code : {levelprofile}</strong>
                {/* <div className="copy-icon" onClick={() => handleCopy(levelprofile)}></div> */}
              </span>
              {/* <span className="referral-code-box">
                <img src="images/profile/star.png" alt="not" />
                <strong>Referral Code: {levelprofile}</strong>
                <div
                  className="copy-icon"
                  onClick={() => handleCopy(levelprofile)}
                ></div>
                {copied && (
                  <span style={{ color: "green", fontSize: "14px" }}>
                    Copied!
                  </span>
                )}
              </span> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileBanner;
